import { Routes } from '@angular/router';
import { File } from './components/file/file';


export const routes: Routes = [ 
  { path: '', component: File, pathMatch: 'full', },
  { path: 'file', component: File },
  { path: '**', redirectTo: 'file' },

];
